(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SatSim", [], factory);
	else if(typeof exports === 'object')
		exports["SatSim"] = factory();
	else
		root["SatSim"] = factory();
})(this, () => {
return 